module.exports = __webpack_public_path__ + "img/搜索引擎(1)@2x.d1ffb70c.png";